window.getPriceOptions = function(marketingMode, label) {

    const priceOptions = {
        selling: [
            {value: 0, text: label},
            {value: 150000, text: '£150,000'},
            {value: 175000, text: '£175,000'},
            {value: 200000, text: '£200,000'},
            {value: 225000, text: '£225,000'},
            {value: 250000, text: '£250,000'},
            {value: 275000, text: '£275,000'},
            {value: 300000, text: '£300,000'},
            {value: 325000, text: '£325,000'},
            {value: 350000, text: '£350,000'},
            {value: 375000, text: '£375,000'},
            {value: 400000, text: '£400,000'},
            {value: 425000, text: '£425,000'},
            {value: 450000, text: '£450,000'},
            {value: 475000, text: '£475,000'},
            {value: 500000, text: '£500,000'},
            {value: 525000, text: '£525,000'},
            {value: 550000, text: '£550,000'},
            {value: 575000, text: '£575,000'},
            {value: 600000, text: '£600,000'},
            {value: 625000, text: '£625,000'},
            {value: 650000, text: '£650,000'},
            {value: 675000, text: '£675,000'},
            {value: 700000, text: '£700,000'},
            {value: 725000, text: '£725,000'},
            {value: 750000, text: '£750,000'},
            {value: 775000, text: '£775,000'},
            {value: 800000, text: '£800,000'},
            {value: 825000, text: '£825,000'},
            {value: 850000, text: '£850,000'},
            {value: 875000, text: '£875,000'},
            {value: 900000, text: '£900,000'},
            {value: 925000, text: '£925,000'},
            {value: 950000, text: '£950,000'},
            {value: 975000, text: '£975,000'},
            {value: 1000000, text: '£1,000,000'},
            {value: 1250000, text: '£1,250,000'},
            {value: 1500000, text: '£1,500,000'},
            {value: 1750000, text: '£1,750,000'},
            {value: 2000000, text: '£2,000,000'},
            {value: 3000000, text: '£3,000,000'},
            {value: 5000000, text: '£5,000,000'}
        ],
        letting: [
            {value: 0, text: label},
            {value: 500, text: '£500 PCM'},
            {value: 600, text: '£600 PCM'},
            {value: 700, text: '£700 PCM'},
            {value: 800, text: '£800 PCM'},
            {value: 900, text: '£900 PCM'},
            {value: 1000, text: '£1,000 PCM'},
            {value: 1250, text: '£1,250 PCM'},
            {value: 1500, text: '£1,500 PCM'},
            {value: 1750, text: '£1,750 PCM'},
            {value: 2000, text: '£2,000 PCM'},
            {value: 2250, text: '£2,250 PCM'},
            {value: 2500, text: '£2,500 PCM'},
            {value: 3000, text: '£3,000 PCM'},
            {value: 3500, text: '£3,500 PCM'},
            {value: 4000, text: '£4,000 PCM'},
            {value: 5000, text: '£5,000 PCM'},
            {value: 6000, text: '£6,000 PCM'},
            {value: 7000, text: '£7,000 PCM'},
            {value: 8000, text: '£8,000 PCM'},
            {value: 9000, text: '£9,000 PCM'},
            {value: 10000, text: '£10,000 PCM'}
        ]
    };

    return priceOptions[marketingMode];
}

window.getTypeOptions = function(marketingMode) {
    const typeOptions = {
        selling: [
            {value: 'all', text: 'Type'},
            {value: 'house', text: 'House'},
            {value: 'flatApartment', text: 'Flat/Apartment'},
            {value: 'land', text: 'Land'},
            {value: 'bungalow', text: 'Bungalow'},
            {value: 'new', text: 'New Homes'},
            {value: 'retirement', text: 'Retirement'},
            {value: 'investment', text: 'Investment'},
            {value: 'other', text: 'Other'}
        ],
        letting: [
            {value: 'all', text: 'Type'},
            {value: 'house', text: 'House'},
            {value: 'flatApartment', text: 'Flat/Apartment'},
            {value: 'bungalow', text: 'Bungalow'},
            {value: 'retirement', text: 'Retirement'},
            {value: 'other', text: 'Other'}
        ]
    };

    return typeOptions[marketingMode];
}
